import { sdk } from 'src/utilities/sdk';
import {
  TaxExemptionCertificate,
  CertificateAttribute,
  CertificateStatus,
  TExCertificateResponseModel,
} from 'src/types/TaxExemptionCertificate';

export const fetchCertificates = async (
  corpId: string
): Promise<TExCertificateResponseModel[]> => {
  const url = `/targetedaudiencesgateway/certificates/corp/${corpId}`;

  return (await sdk.http.get(url)) as TExCertificateResponseModel[];
};

export const transform = (
  certificates: TExCertificateResponseModel[]
): TaxExemptionCertificate[] => {
  return certificates.map((cert) => {
    return {
      [CertificateAttribute.certificateId]: cert.certificate_id,
      [CertificateAttribute.name]: cert.name,
      [CertificateAttribute.state]: cert.state,
      [CertificateAttribute.status]:
        CertificateStatus[cert.status] || CertificateStatus.UNTRACKED,
      [CertificateAttribute.expirationDate]: cert.expiration_date,
    };
  });
};
